// Quick Add Siblings
document.addEventListener('option:accordian:trigger', () => {
  document.querySelectorAll('.Sibling-grp-card').forEach((card) => {
    card.addEventListener('click', function (e) {
      if (e.target.closest('radio-swatch') || e.target.closest('a')) return;

      document
        .querySelectorAll('.Sibling-grp-card')
        .forEach((c) => c.classList.remove('is-active'));
      this.classList.add('is-active');
    });
  });

  const dataEl = document.getElementById('sibling-variants-data');
  if (!dataEl) return;

  const variantData = JSON.parse(dataEl.textContent);

  function getSelectedSize() {
    const checked = document.querySelector(
      'input[type="radio"][name*="Size"]:checked'
    );
    return checked ? checked.value : null;
  }

  function updateSiblingsAvailability() {
    const selectedSize = getSelectedSize();
    if (!selectedSize) return;

    document.querySelectorAll('radio-swatch').forEach((swatch) => {
      const handle = swatch.dataset.siblingHandle; 
      const link = swatch.querySelector('.sibling__link');

      if (!handle || !link || !variantData[handle]) return;

      const matchingVariant = variantData[handle].variants.find((v) =>
        v.options.includes(selectedSize)
      );

      if (matchingVariant && matchingVariant.available === false) {
        link.classList.add('sibling__link--variant-soldout');
      } else {
        link.classList.remove('sibling__link--variant-soldout');
      }
    });
  }

  setTimeout(updateSiblingsAvailability, 0);

  document
    .querySelectorAll('input[type="radio"][name*="Size"]')
    .forEach((radio) => {
      radio.addEventListener('change', updateSiblingsAvailability);
    });
});


document.addEventListener('DOMContentLoaded', () => {
    function quicl_view(){
        document.querySelectorAll('.qview_gallery_slider').forEach((slider) => {
            new Swiper(slider, {
                slidesPerView: 1.1,
                spaceBetween: 10,
            });
        });
    }
    document.addEventListener('option:accordian:trigger', () => {
       quicl_view();
       console.log("Triggered")
    })
});


